import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";
import {showLoader} from "../../../components/loader/loader";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import MapConfigForm from "./_form";
import MapConfigList from "./_list";

function MapConfig(props) {
    // Modo de vista: LIST, FORM
    const { loading } = props.mainProps
    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (udn !== null)
            props.setUdn(udn);
    },[]);

    const createItem = () => {
        props.setForm()
        ModalFormContainer(MapConfigForm, { data: null, Form: MapConfigForm });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem}/>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <MapConfigList />
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading,
    clearListState
});

export default connect(mapStateToProps, mapActionsToProps)(MapConfig)
